import { Link } from "react-router-dom";
import { LOGO } from "@/lib/config";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-boco-navy flex items-center justify-center px-5">
      <div className="max-w-md w-full rounded-3xl bg-white p-10 text-center shadow-2xl" data-testid="payment-cancel">
        <img src={LOGO} alt="BOCO BINS" className="mx-auto h-16 w-16 rounded-full object-cover" />
        <XCircle className="mx-auto mt-6 h-14 w-14 text-slate-400" />
        <h1 className="mt-4 font-display text-2xl font-black text-boco-navy">Checkout Canceled</h1>
        <p className="mt-2 text-slate-600">No worries — your card was not charged. You can pick up right where you left off.</p>
        <Link to="/book" className="mt-6 inline-flex rounded-full bg-boco-green px-7 py-3 font-bold text-boco-navy hover:bg-boco-greendark hover:text-white transition-colors" data-testid="cancel-retry-btn">Return to Booking</Link>
      </div>
    </div>
  );
}
